import { useAtom, atom } from 'jotai';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { addAdditionalInquiry } from "../../api/api";

const attachedFileAtom = atom();
const acceptanceNumberAtom = atom();
const customerStatusAtom = atom();
const subjectAtom = atom();
const customerNameAtom = atom();
const modelNameAtom = atom();
const modelNumberAtom = atom();
const osNameAtom = atom();
const osVersionAtom = atom();
const relatedHardware1Atom = atom();
const relatedHardwareModelNumber1Atom = atom();
const relatedHardware2Atom = atom();
const relatedHardwareModelNumber2Atom = atom();
const relatedSoftwareAtom = atom();
const relatedSoftwareModelNumberAtom = atom();
const inquiryCategoryAtom = atom(
    {
        0: "追加質問",
        1: "情報提供",
        2: "再確認",
        3: "進捗確認",
        4: "クローズ"
    }
);
const questionAreaAtom = atom();


function MainComponent({ handleLoading }) {

    document.title = "継続お問い合わせ（確認用）| ファーストコンタクトセンター";
    const location = useLocation();
    const navigate = useNavigate();
    const [attachedFile, setAttachedFile] = useAtom(attachedFileAtom);
    const [acceptanceNumber, setAcceptanceNumber] = useAtom(acceptanceNumberAtom);
    const [customerStatus, setCustomerStatus] = useAtom(customerStatusAtom);
    const [subject, setSubject] = useAtom(subjectAtom);
    const [customerName, setCustomerName] = useAtom(customerNameAtom);
    const [modelName, setModelName] = useAtom(modelNameAtom);
    const [modelNumber, setModelNumber] = useAtom(modelNumberAtom);
    const [osName, setOsName] = useAtom(osNameAtom);
    const [osVersion, setOsVersion] = useAtom(osVersionAtom);
    const [relatedHardware1, setRelatedHardware1] = useAtom(relatedHardware1Atom);
    const [relatedHardwareModelNumber1, setRelatedHardwareModelNumber1] = useAtom(relatedHardwareModelNumber1Atom);
    const [relatedHardware2, setRelatedHardware2] = useAtom(relatedHardware2Atom);
    const [relatedHardwareModelNumber2, setRelatedHardwareModelNumber2] = useAtom(relatedHardwareModelNumber2Atom);
    const [relatedSoftware, setRelatedSoftware] = useAtom(relatedSoftwareAtom);
    const [relatedSoftwareModelNumber, setRelatedSoftwareModelNumber] = useAtom(relatedSoftwareModelNumberAtom);
    const [inquiryCategory] = useAtom(inquiryCategoryAtom);
    const [questionArea, setquestionArea] = useAtom(questionAreaAtom);
    setAttachedFile(parseInt(location.state.attachedFile));
    setAcceptanceNumber(location.state.acceptanceNumber);
    setCustomerStatus(location.state.customerStatus);
    setSubject(location.state.subject)
    setCustomerName(location.state.customerName);
    setModelName(location.state.modelName);
    setModelNumber(location.state.modelNumber);
    setOsName(location.state.osName);
    setOsVersion(location.state.osVersion);
    setRelatedHardware1(location.state.relatedHardware1);
    setRelatedHardwareModelNumber1(location.state.relatedHardwareModelNumber1);
    setRelatedHardware2(location.state.relatedHardware2);
    setRelatedHardwareModelNumber2(location.state.relatedHardwareModelNumber2);
    setRelatedSoftware(location.state.relatedSoftware);
    setRelatedSoftwareModelNumber(location.state.relatedSoftwareModelNumber);
    setquestionArea(location.state.questionArea);
    const confirm = async () => {
        let acceptanceNumber = location.state.acceptanceNumber
        let inquiryCategory = location.state.inquiryCategory
        handleLoading(true)
        try {
            let data = await addAdditionalInquiry(
                acceptanceNumber,
                questionArea,
                attachedFile,
                inquiryCategory,);
            if (data === false) {
                alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。尚、特定のセキュリティ上のリスクを伴う文字・表現が含まれている場合にもエラーとなる可能性がございます。詳細は前ページの「更新内容」の説明をご覧ください。")
                throw new Error("追加失敗");
            }
            const caseId = data.acceptanceNumber; //資料登録の caseIDに紐づく
            const contactId = data.contactId;
            var next_state = {
                userName: "",
                companyName: "",
                divisionName: "",
                secretInfo: "",
                personalInfo: "",
                caseId: caseId,
                contactId: contactId
            };
            handleLoading(false);
            if (parseInt(location.state.attachedFile) === 1) {
                navigate("/file_info_edit", {
                    state: {
                        next_state: next_state,
                        page: true
                    }
                })

            }
            if (parseInt(location.state.attachedFile) === 0) {
                navigate("/inquiry_completion", { state: { page: true } })
            }
        } catch (e) {
            // TODO エラー表示
            ;
        } finally {
            handleLoading(false);
        }
    }

    const goBack = () => {

        navigate("/relation_inquiry_create", {
            state: {
                acceptanceNumber: location.state.acceptanceNumber,
                inquiryCategory: location.state.inquiryCategory,
                questionArea: location.state.questionArea,
                attachedFile: location.state.attachedFile,
                customerStatus: location.state.customerStatus,
                subject: location.state.subject,
                customerName: location.state.customerName,
                operationType: location.state.operationType,
                modelName: location.state.modelName,
                modelNumber: location.state.modelNumber,
                osName: location.state.osName,
                osVersion: location.state.osVersion,
                relatedHardware1: location.state.relatedHardware1,
                relatedHardwareModelNumber1: location.state.relatedHardwareModelNumber1,
                relatedHardware2: location.state.relatedHardware2,
                relatedHardwareModelNumber2: location.state.relatedHardwareModelNumber2,
                relatedSoftware: location.state.relatedSoftware,
                relatedSoftwareModelNumber: location.state.relatedSoftwareModelNumber,
                records: location.state.records,
                searchAccNum: location.state.searchAccNum,
                searchDateFrom: location.state.searchDateFrom,
                searchDateTo: location.state.searchDateTo,
                searchCustomerStatusNum: location.state.searchCustomerStatusNum,
                searchEndUser: location.state.searchEndUser,
                page: "return"
            }
        })

    }


    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">
                <div className="str-inner">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <h2 className="mod-hdg-l2-02">
                        <span>継続お問い合わせ(確認用)</span>
                    </h2>
                    <div className="mod-tbl-form">
                        <div style={{ marginBottom: "15px" }}>
                            <div> お問い合わせ内容を下記に表示していますので、内容を確認の上、確認ボタンを押してください。</div>
                            <div> 添付資料「あり」の場合は、確認ボタン押下後、資料登録する画面が表示されます。</div>
                            <div> 管理情報を入力した後、添付ファイル アップロード画面で添付資料のアップロードを行ってください。</div>
                        </div>

                        <table role="presentation">
                            <colgroup>
                                <col className="w-35" />
                                <col />
                            </colgroup>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>受付番号</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input" id="receipt_num">
                                            {acceptanceNumber ? acceptanceNumber : "（未入力）"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>お問い合わせ状況</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input" id="inquiry_state">
                                            {customerStatus ? customerStatus : "（未入力）"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>件名</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input" id="title">
                                            {subject ? subject : "（未入力）"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>運用形態</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input" id="ope_form">
                                            {location.state.operationType ? location.state.operationType : "（未入力）"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>お客様名(エンドユーザ様名)</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input" id="end_user">
                                            {customerName ? customerName : "（未入力）"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            {inquiryCategory[location.state.inquiryCategory] ? (<tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>お問い合わせ区分</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input" id="inquiry_category">
                                            {inquiryCategory[location.state.inquiryCategory]}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>) : (<></>)}

                            {questionArea ? (<tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>更新内容</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-pre-wrap" id="inquiry_contents">
                                            {questionArea}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>) : (<></>)}

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>添付ファイル有無</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input" id="attached_file">
                                            {attachedFile === 1 ? "あり" : "なし"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>マイナンバー（個人番号）の確認</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input">
                                            お問い合わせ内容および添付資料にマイナンバーは含まれません。
                                        </div>
                                    </td>
                                </tr>
                            </tbody>


                        </table>
                    </div>
                </div>
                <div id="inquiry_list" className="mod-tbl" style={{ marginBottom: "5px" }}>
                </div>
                <div id="inquiry_product" className="mod-tbl-form">
                    <table role="presentation">
                        <colgroup>
                            <col className="w-35" />
                            <col />
                        </colgroup>

                        <tbody>
                            <tr>
                                <td className="caption">
                                    <div className="inner">
                                        <b>本体</b>
                                    </div>
                                </td>
                                <td>
                                    <div className="mod-input" id="model_name">
                                        {modelName ? modelName : "（未入力）"}
                                    </div>
                                </td>
                            </tr>
                        </tbody>

                        {modelName ? (<tbody>
                            <tr>
                                <td className="caption">
                                    <div className="inner">
                                        <b>型番</b>
                                    </div>
                                </td>
                                <td>
                                    <div className="mod-input" id="model_num">
                                        {modelNumber ? modelNumber : "（未入力）"}
                                    </div>
                                </td>
                            </tr>
                        </tbody>) : null}

                        <tbody>
                            <tr>
                                <td className="caption">
                                    <div className="inner">
                                        <b>OS</b>
                                    </div>
                                </td>
                                <td>
                                    <div className="mod-input" id="os_name">
                                        {osName ? osName : "（未入力）"}
                                    </div>
                                </td>
                            </tr>
                        </tbody>

                        {osName ? (<tbody>
                            <tr>
                                <td className="caption">
                                    <div className="inner">
                                        <b>OSバージョン</b>
                                    </div>
                                </td>
                                <td>
                                    <div className="mod-input" id="os_ver">
                                        {osVersion ? osVersion : "（未入力）"}
                                    </div>
                                </td>
                            </tr>
                        </tbody>) : null}

                        {relatedHardware1 ? (<tbody id="hw_name1_body">
                            <tr>
                                <td className="caption">
                                    <div className="inner">
                                        <b>関連ハードウェア1</b>
                                    </div>
                                </td>
                                <td>
                                    <div className="mod-input" id="related_hw_id">
                                        {relatedHardware1}
                                    </div>
                                </td>
                            </tr>
                        </tbody>) : null}

                        {relatedHardware1 ? (<tbody id="hw_model1_body">
                            <tr>
                                <td className="caption">
                                    <div className="inner">
                                        <b>関連ハードウェア型番1</b>
                                    </div>
                                </td>
                                <td>
                                    <div className="mod-input" id="related_hw_num">
                                        {relatedHardwareModelNumber1 ? relatedHardwareModelNumber1 : "（未入力）"}
                                    </div>
                                </td>
                            </tr>
                        </tbody>) : null}

                        {relatedHardware2 ? (<tbody id="hw_name2_body">
                            <tr>
                                <td className="caption">
                                    <div className="inner">
                                        <b>関連ハードウェア2</b>
                                    </div>
                                </td>
                                <td>
                                    <div className="mod-input" id="related_hw_id">
                                        {relatedHardware2}
                                    </div>
                                </td>
                            </tr>
                        </tbody>) : null}

                        {relatedHardware2 ? (<tbody id="hw_model2_body">
                            <tr>
                                <td className="caption">
                                    <div className="inner">
                                        <b>関連ハードウェア型番2</b>
                                    </div>
                                </td>
                                <td>
                                    <div className="mod-input" id="related_hw_num">
                                        {relatedHardwareModelNumber2 ? relatedHardwareModelNumber2 : "（未入力）"}
                                    </div>
                                </td>
                            </tr>
                        </tbody>) : null}

                        {relatedSoftware ? (<tbody id="sw_name_body">
                            <tr>
                                <td className="caption">
                                    <div className="inner">
                                        <b>関連ソフトウェア</b>
                                    </div>
                                </td>
                                <td>
                                    <div className="mod-input" id="related_sw_id">
                                        {relatedSoftware}
                                    </div>
                                </td>
                            </tr>
                        </tbody>) : null}

                        {relatedSoftware ? (<tbody id="sw_model_body">
                            <tr>
                                <td className="caption">
                                    <div className="inner">
                                        <b>関連ソフトウェア型番</b>
                                    </div>
                                </td>
                                <td>
                                    <div className="mod-input" id="related_sw_num">
                                        {relatedSoftwareModelNumber ? relatedSoftwareModelNumber : "（未入力）"}
                                    </div>
                                </td>
                            </tr>
                        </tbody>) : null}
                    </table>
                </div>
                <div className="mod-btn of-list">
                    <div className="btn">
                        <button id="btn-go-top" className="of-left"
                            onClick={goBack}>戻る</button>
                    </div>
                    <div className="btn">
                        <button type="button" id="btn-send" className="btn_default_select"
                            onClick={confirm}>確認</button>
                    </div>
                </div>

            </div>
        </div >
    )
}

export default MainComponent;